export default __webpack_public_path__ + "static/ProServices-Photo1-339d402a3a987856dafe083569751639.png";